export const STATUSES_LEGEND = {
  Critical: 'critical',
  High: 'high',
  Standard: 'standard',
  'no ai': 'noAi',
  Inactive: 'inactive',
  on_hold: 'onHold',
};
